export interface TextValidation {
	name:
		| 'min-word-count'
		| 'max-word-count'
		| 'reject-unrecognized-words'
		| 'reject-excess-repetition'
		| 'no-direct-quotes'
		| 'citation-count';
	enabled: boolean;
	parameters: {
		minimum?: number;
		maximum?: number;
		optimum?: number;
	};
	rejoinders: string[];
	element_override: boolean;
}

export const validationsMock: TextValidation[] = [
	{
		name: 'min-word-count',
		enabled: true,
		parameters: {
			minimum: 45
		},
		rejoinders: [
			'Your response is too short. Please revise and try to post again.',
			'Your response is still too short. Keep going! If you need help, contact our support team.'
		],
		element_override: false
	},
	{
		name: 'max-word-count',
		enabled: true,
		parameters: {
			maximum: 45
		},
		rejoinders: ['Your response is too long. Please shorten your answer and try to post again.'],
		element_override: false
	},
	{
		name: 'reject-unrecognized-words',
		enabled: true,
		parameters: {
			minimum: 0.5
		},
		rejoinders: ['Unrecognized words. Check your response for misspelled words and try again.'],
		element_override: false
	},
	{
		name: 'reject-excess-repetition',
		enabled: true,
		parameters: {
			minimum: 0.5
		},
		rejoinders: [
			'Your response has too many repeated words or phrases. Check your response for repetitive words and try again.'
		],
		element_override: false
	}
];
